import React, { useEffect, useState } from "react";
import _ from "lodash";

import makeStyles from '@mui/styles/makeStyles';

import TopBar from "../TopBar";
import LiveContentContainer from "../LiveContentContainer";
import UpcomingContentContainer from "../UpcomingContentContainer";
import ZoomService from "../../services/ZoomService";
import UserService from "../../services/UserService";
import LanguageContext from "../../LanguageContext";
import JWTTokenContext from "../../JWTTokenContext";
import CarousalContainer from "./../CarousalContainer";
import messages from "../../services/messages";
import content from "../../services/content";
import CropsListContainer from "../CropsListContainer";
import firebase from "../../firebase";
import LiveHelpContainer from "../LiveHelpContainer";
import * as packageInfo from "../../../package.json";
import moment from "moment";
import LeadService from "../../services/LeadService";
import StateService from "../../services/StateService";
import HowToUseDialog from "./HowToUseDialog";
import LeadDialog from "./LeadDialog";
import WelcomeDialog from "./WelcomeDialog";
import Refcard from "../Refcard";
import CropService from "../../services/CropService";
import BottomBar from "../BottomBar";
import ErrorBoundary from "../ErrorBoundry";
import BannerContainer from "./BannerContainer";
const version="2.10.0"
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F3F3F3",
    minHeight: window.innerHeight,
  },
  item: {
    textAlign: "center",
    padding: "4px",
    margin: "2px 0px",
  },

  greySection: {
    background: "#f1f1f1",
    padding: "4vh 0vh",
  },
  whiteSection: {
    background: "#fff",
    padding: "4vh 0vh 0vh 0vh",
    marginTop: "3%",
    "@media (max-width: 1200px)": {
      marginTop: "10%",
    },
  },
  whatYouGetTitleContainer: {
    marginBottom: theme.spacing(2),
  },
  whatYouGetText: {
    marginLeft: theme.spacing(4),
  },
  whatYouGetContainer: {
    marginTop: theme.spacing(4),
  },
  whatYouGetContent: {
    marginBottom: theme.spacing(3),
  },
  benefitContainer: {
    marginBottom: theme.spacing(3),
  },
  carousalMarginFree: {
    marginTop: "32px",
  },
  carousalMarginPaid: {
    marginTop: "32px",
  },
  welcomeDialog: {},
  welcomeDialogIcon: {
    height: theme.spacing(3),
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
  },
  leadRegistrationSuccessDialogIcon: {
    height: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  welcomeDialogTitle: {
    marginBottom: theme.spacing(-1),
  },
  leadRegistrationSuccessDialogTitle: {
    marginBottom: theme.spacing(-1),
  },
  welcomeDialogActions: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(-1),
  },
  welcomeDialogClose: {
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(1),
  },
  welcomeDialogBody: {
    color: "black",
  },
  welcomeDialogText: {
    marginLeft: theme.spacing(0),
    fontWeight: "bold",
  },
}));

const meetingType = `meetings`;

function Dashboard(props) {
  const classes = useStyles();

  let [jwtToken, setJwtToken] = useState("");
  let [userLanguageCode, setUserLanguageCode] = useState();
  let [userState, setUserState] = useState();
  let [recordedMeetings, setRecordedMeetings] = useState({});
  let [loadingRecordedMeetings, setLoadingRecordedMeetings] = useState(true);
  let [loading, setLoading] = useState(true);
  let [upcomingMeetings, setUpcomingMeetings] = useState({});
  let [allUpcomingMeetings, setAllUpcomingMeetings] = useState([]);
  let [allMeetingsByCrop, setAllMeetingsByCrop] = useState({});
  let [nextUpcomingTime, setNextUpcomingTime] = useState("");
  let [loadingUpcomingMeetings, setLoadingUpcomingMeetings] = useState(true);
  let [liveMeetings, setLiveMeetings] = useState([]);
  let [loadingLiveMeetings, setLoadingLiveMeetings] = useState(true);
  let [loadingLiveHelpMeetings, setLoadingLiveHelpMeetings] = useState(true);
  let [successVideos, setSuccessVideos] = useState([]);
  let [liveHelpVideos, setLiveHelpVideos] = useState([]);
  let [mobile, setMobile] = useState(null);
  let [name, setName] = useState(null);
  let [free, setFree] = useState(false);
  let userTypeVar = "premium";
  let [userType, setUserType] = useState(userTypeVar);
  let [openWelcome, setOpenWelcome] = useState(false);
  let [openHowToUseVideo, setOpenHowToUseVideo] = useState(false);
  let [cropList, setCropList] = useState([]);
  let [loadingCropList, setLoadingCropList] = useState(false);
  let [userData, setUserData] = useState(null);
  let [openLeadRegistrationSuccess, setOpenLeadRegistrationSuccess] =
    useState(false);
  let [farmerCrops, setFarmerCrops] = useState([]);

  let [userSource, setUserSource] = useState("");
  const handleCloseLeadRegistrationSuccess = () => {
    setOpenLeadRegistrationSuccess(false);
  };
  const handleHowToUse = () => {
    setOpenHowToUseVideo(true);
    firebase.analytics().logEvent("howtouse_video_dialog_opened", {
      page: "dashboard",
      section: "howtouse_message",
      state_name: userState.name_en,
      mobile: mobile,
      user_type: userType,
      user_source: userSource,
    });
    // setOpenWelcome(false);
  };
  const handleWelcome = () => {
    setOpenWelcome(true);
    firebase.analytics().logEvent("howtouse_video_dialog_opened", {
      page: "dashboard",
      section: "welcome_dialog",
      state_name: userState.name_en,
      mobile: mobile,
      user_type: userType,
      user_source: userSource,
    });
    // setOpenWelcome(false);
  };
  const handleCloseHowToUseVideo = () => {
    setOpenHowToUseVideo(false);
    firebase.analytics().logEvent("howtouse_video_dialog_closed", {
      page: "dashboard",
      section: "welcome_dialog",
      state_name: userState.name_en,
      mobile: mobile,
      user_type: userType,
      user_source: userSource,
    });
  };

  const handleClose = () => {
    setOpenWelcome(false);
    firebase.analytics().logEvent("welcome_dialog_closed", {
      state_name: userState.name_en,
      mobile: mobile,
      user_type: userType,
      user_source: userSource,
    });
  };

  const fetchMeetings = async () => {
    setLoading(true);
    setLoadingCropList(true);

    let { crops, authors, states } = props.referenceData;

    let userStateFromLocal = localStorage.state;
    let userLangCodeFromLocal = localStorage.languageCode;

    let userSourceFromLocal = localStorage.userSource;
    let userSourceVar = "";
    if (!userSourceFromLocal || userSourceFromLocal === "") {
      userSourceVar = "WEB";
    } else {
      userSourceVar = userSourceFromLocal;
    }

    setUserSource(userSourceVar);

    let userStateName = userStateFromLocal.toString();
    let userLanguageCodeVar = userLangCodeFromLocal;

    let freeVar = false;
    let userResponse = await UserService.getUser();

    let userFromResponse = userResponse.data;

    if (userFromResponse.name) {
      setName(userFromResponse.name);
    }
    if (userFromResponse) {
      setUserData(userFromResponse);
    }

    if (userFromResponse.premium === false) {
      setFree(true);
      freeVar = true;
      userTypeVar = "free";
      setUserType(userTypeVar);
      localStorage.setItem("premium", userFromResponse.premium);
    } else {
      if (userFromResponse.migrated === true) {
        userTypeVar = "free_premium";
        setUserType(userTypeVar);
      } else if (userFromResponse.subscription_type === "free_premium") {
        userTypeVar = "free_premium";
        setUserType(userTypeVar);
      }
      if (
        userFromResponse.subscription_type &&
        userFromResponse.subscription_type === "freemium_1_month"
      ) {
        userTypeVar = "freemium_1_month";
        setUserType(userTypeVar);
      }
    }

    let mobileVar = "";
    if (userFromResponse.mobile) {
      setMobile(userFromResponse.mobile);
      mobileVar = userFromResponse.mobile;
      firebase.analytics().setUserId(userFromResponse.mobile);
      firebase.analytics().logEvent("dashboard_page_viewed", {
        state_name: userStateName,
        mobile: userFromResponse.mobile,
        user_type: userTypeVar,
        user_source: userSourceVar,
        gold_version: version,
      });
    }
    if (
      !userStateFromLocal ||
      userStateFromLocal === "" ||
      !userLangCodeFromLocal ||
      userLangCodeFromLocal === ""
    ) {
      if (userFromResponse.state) {
        let userStateFromResponse =
          userFromResponse.state.name_en.toLowerCase();
        let stateFromResponse = userFromResponse.state;
        localStorage.setItem("state", userStateFromResponse);
        setUserState(stateFromResponse);
        userStateName = userStateFromResponse;
        if (userFromResponse.state.language) {
          let userLangCodeFromResponse = userFromResponse.state.language.code;
          localStorage.setItem("languageCode", userLangCodeFromResponse);
          userLanguageCodeVar = userLangCodeFromResponse;
          setUserLanguageCode(userLangCodeFromResponse);
        } else {
          userLanguageCodeVar = "mr";
          setUserLanguageCode("mr");
        }
      } else {
        setUserState(StateService.getStateByName(states, "maharashtra"));
        userStateName = "maharashtra";
        userLanguageCodeVar = "mr";
        setUserLanguageCode("mr");
      }
    } else {
      setUserState(StateService.getStateByName(states, userStateFromLocal));
      setUserLanguageCode(userLangCodeFromLocal);
    }

    if (userFromResponse.crops && userFromResponse.crops.length > 0) {
      let userCrops = userFromResponse.crops;

      userCrops = userCrops.filter((userCrop) => {
        return CropService.getCropByName(crops, userCrop.name)
          ? CropService.getCropByName(crops, userCrop.name)
          : false;
      });

      userCrops = userCrops.map((userCrop) => {
        return {
          ...userCrop,
          ...CropService.getCropByName(crops, userCrop.name),
        };
      });

      userCrops = userCrops.filter((userCrop) => {
        let videosCount = 0;
        videosCount = CropService.getVideosCount(
          userCrop,
          userStateName,
          userTypeVar
        );

        if (userCrop.type === "gold_crop") {
          if (videosCount && videosCount > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });

      userCrops = userCrops.map((userCrop) => {
        let videosCount = 0;
        videosCount = CropService.getVideosCount(
          userCrop,
          userStateName,
          userTypeVar
        );
        if (videosCount && videosCount > 0) {
          return { ...userCrop, total_videos_count: videosCount };
        } else {
          return { ...userCrop };
        }
      });

      setCropList(userCrops);
      setLoadingCropList(false);
    }

    let { isNew } = UserService.getUserInfo();

    if (isNew === "true") {
      // setOpenWelcome(true);
      // firebase.analytics().logEvent("welcome_dialog_shown", {
      //   state_name: userStateName,
      //   mobile: mobile,
      //   user_type: userType,
      //   user_source: userSourceVar,
      // });
      if (userSourceVar === "WEB") {
        LeadService.registerLead(userStateName, mobileVar, "New User Joined")
          .then((leadResponse) => {
            firebase.analytics().logEvent("lead_added", {
              state_name: userStateName,
              mobile: mobile,
              user_type: userType,
              remarks: "New User Joined",
              user_source: userSource,
            });
          })
          .catch((leadError) => {
            firebase.analytics().logEvent("lead_addition_failed", {
              state_name: userStateName,
              mobile: mobile,
              user_type: userType,
              remarks: "New User Joined",
              user_source: userSource,
            });
          });
      }

      localStorage.setItem("isNew", false);
    }
    let videoKey = "success.video.";
    if (userStateName) {
      let successVideosByCrop =
        content["success.video"][userStateName.toLowerCase()];

      videoKey += userStateName;
      let successVideoKeys = Object.keys(successVideosByCrop);
      let successVideosArray = successVideoKeys.map((successVideoKey) => {
        return {
          key: videoKey + "." + successVideoKey,
          ...successVideosByCrop[successVideoKey],
        };
      });

      setSuccessVideos(successVideosArray);
    } else {
      //return;
      let successVideosByCrop = content["success.video"]["maharashtra"];
      videoKey += "maharashtra";
      let successVideoKeys = Object.keys(successVideosByCrop);
      let successVideosArray = successVideoKeys.map((successVideoKey) => {
        return {
          key: videoKey + "." + successVideoKey,
          ...successVideosByCrop[successVideoKey],
        };
      });
      setSuccessVideos(successVideosArray);
    }

    ZoomService.getJWTToken().then((response) => {
      let token = response.data.token;
      setJwtToken(token);
    });

    setLoadingUpcomingMeetings(true);
    setLoadingLiveMeetings(true);
    setLoadingRecordedMeetings(true);
    setLoadingLiveHelpMeetings(true);

    ZoomService.getLiveMeetings(userStateName).then((response) => {
      let meetingsResponse = response.data;

      let meetings = meetingsResponse;

      let liveMeetingsFromService = ZoomService.parseMeetings(
        meetings,
        userLanguageCodeVar,
        userStateName,
        crops,
        states,
        authors
      );

      if (freeVar === true) {
        liveMeetingsFromService = _.filter(
          liveMeetingsFromService,
          (meeting) => {
            return meeting.free === true;
          }
        );
      }

      setLiveMeetings(liveMeetingsFromService);
      setLoadingLiveMeetings(false);

      ZoomService.getLiveLiveHelp(userStateName).then((response) => {
        let meetingsResponse = response.data;

        let meetings = meetingsResponse;

        let parsedLiveHelpVideos = ZoomService.parseLiveHelp(
          meetings,
          "live",
          states,
          userStateName
        );

        if (freeVar === true) {
          parsedLiveHelpVideos = _.filter(parsedLiveHelpVideos, (meeting) => {
            return meeting.free === true;
          });
        }

        ZoomService.getUpcomingLiveHelp(userStateName).then((response) => {
          let upcomingMeetingsResponse = response.data;

          let upcomingLiveHelpMeetings = upcomingMeetingsResponse;

          let parsedUpcomingLiveHelpVideos = ZoomService.parseLiveHelp(
            upcomingLiveHelpMeetings,
            "upcoming",
            states,
            userStateName
          );

          if (freeVar === true) {
            parsedUpcomingLiveHelpVideos = _.filter(
              parsedUpcomingLiveHelpVideos,
              (meeting) => {
                return meeting.free === true;
              }
            );
          }

          parsedUpcomingLiveHelpVideos = _.filter(
            parsedUpcomingLiveHelpVideos,
            (upcomingElement) => {
              return !_.some(parsedLiveHelpVideos, (liveElement) => {
                return liveElement.id === upcomingElement.id;
              });
            }
          );
          let updatedVideos = [
            ...parsedLiveHelpVideos,
            ...parsedUpcomingLiveHelpVideos.slice(0, 1),
          ];

          setLiveHelpVideos(updatedVideos);
          setLoadingLiveHelpMeetings(false);
        });

        ZoomService.getUpcomingMeetings(userStateName).then((response) => {
          let upcomingMeetingsResponse = response.data;

          let upcomingMeetings = upcomingMeetingsResponse;

          let upcomingMeetingsFromService = ZoomService.parseMeetings(
            upcomingMeetings,
            userLanguageCodeVar,
            userStateName,
            crops,
            states,
            authors
          );

          if (freeVar === true) {
            upcomingMeetingsFromService = _.filter(
              upcomingMeetingsFromService,
              (meeting) => {
                return meeting.free === true;
              }
            );
          }

          upcomingMeetingsFromService = _.filter(
            upcomingMeetingsFromService,
            (upcomingElement) => {
              return !_.some(liveMeetingsFromService, (liveElement) => {
                return liveElement.id === upcomingElement.id;
              });
            }
          );

          if (
            upcomingMeetingsFromService &&
            upcomingMeetingsFromService.length > 0
          ) {
            let nextStartDateTime = upcomingMeetingsFromService[0].startTime; //04 Feb , 9:00 PM
            let nextStartDateTimeArr = nextStartDateTime.split(",");

            if (nextStartDateTimeArr && nextStartDateTimeArr.length === 2) {
              let nextStartTime = nextStartDateTimeArr[1].trim();
              let nextStartTimeArr = nextStartTime.split(" ");

              if (nextStartTimeArr && nextStartTimeArr.length === 2) {
                let nextStartTimeWithoutMeridian = nextStartTimeArr[0];

                if (nextStartTimeWithoutMeridian) {
                  let meetingDate = moment(
                    nextStartDateTimeArr[0].trim() + " 2021",
                    "DD MMM YYYY"
                  );
                  if (moment(meetingDate).isAfter(moment(), "day")) {
                    //tomorrow
                    setNextUpcomingTime(
                      messages["dashboard.live.tomorrow"][userLanguageCodeVar] +
                        " " +
                        nextStartTimeWithoutMeridian
                    );
                  } else if (
                    moment(meetingDate).isAfter(moment().add(1, "days"), "day")
                  ) {
                    //day after tomorrow
                    setNextUpcomingTime(
                      messages["dashboard.live.dayAfterTomorrow"][
                        userLanguageCodeVar
                      ] +
                        " " +
                        nextStartTimeWithoutMeridian
                    );
                  } else if (
                    moment(meetingDate).isAfter(moment().add(2, "days"), "day")
                  ) {
                    //2 days after
                    setNextUpcomingTime(
                      messages["dashboard.live.twoDaysAfterTomorrow"][
                        userLanguageCodeVar
                      ] +
                        " " +
                        nextStartTimeWithoutMeridian
                    );
                  } else {
                    setNextUpcomingTime(nextStartTimeWithoutMeridian);
                  }
                }
              }
            }
          }
          let upcomingMeetingsByCrop = ZoomService.mapByCrop(
            upcomingMeetingsFromService
          );

          setAllUpcomingMeetings(upcomingMeetingsFromService);
          setUpcomingMeetings(upcomingMeetingsByCrop);

          setLoadingUpcomingMeetings(false);

          ZoomService.getRecordedMeetings(userStateName).then((response) => {
            let meetingsResponse = response.data;

            let meetings = meetingsResponse;

            let recordedMeetingsFromService = ZoomService.parseMeetings(
              meetings,
              userLanguageCodeVar,
              userStateName,
              crops,
              states,
              authors
            );

            if (freeVar === true) {
              recordedMeetingsFromService = _.filter(
                recordedMeetingsFromService,
                (meeting) => {
                  return meeting.free === true;
                }
              );
            }

            recordedMeetingsFromService = ZoomService.filterRecordings(
              recordedMeetingsFromService
            );

            let recordedMeetingsByCrop = ZoomService.mapByCrop(
              recordedMeetingsFromService
            );

            setRecordedMeetings(recordedMeetingsByCrop);
            setLoadingRecordedMeetings(false);

            let allMeetingsByCrop = ZoomService.mapAllByCrop(
              liveMeetingsFromService,
              upcomingMeetingsFromService,
              recordedMeetingsFromService,
              crops
            );
            setAllMeetingsByCrop(allMeetingsByCrop);

            setLoading(false);
          });
        });
      });
    });
  };
  useEffect(() => {
    if (
      props.referenceData &&
      !_.isEmpty(props.referenceData) &&
      props.loadingMasterData === "done"
    ) {
      fetchMeetings().then(() => {});
      UserService.logUser();
    }
  }, [props.referenceData]);

  return (
    <div className={classes.root}>
      <LanguageContext.Provider value={userLanguageCode}>
        {userSource && userSource !== `` && userSource !== "EMBED" && (
          <ErrorBoundary
            page={"dashboard"}
            section={"topbar"}
            userSource={userSource}
          >
            <TopBar userSource={userSource} />
          </ErrorBoundary>
        )}

        {userSource === "EMBED" && userLanguageCode && userLanguageCode !== "" && (
          <ErrorBoundary
            page={"dashboard"}
            section={"topbar"}
            userSource={userSource}
          >
            <BannerContainer />
          </ErrorBoundary>
        )}

        <ErrorBoundary
          page={"dashboard"}
          section={"live-meetings"}
          userSource={userSource}
        >
          <LiveContentContainer
            liveMeetings={liveMeetings}
            allUpcomingMeetings={
              allUpcomingMeetings && allUpcomingMeetings.length > 0
                ? [allUpcomingMeetings[0]]
                : []
            }
            loading={loadingUpcomingMeetings}
            crops={props.referenceData.crops}
            userType={userType}
            nextUpcomingTime={nextUpcomingTime}
            farmerCrops={farmerCrops}
            userSource={userSource}
            showHowToUse={false}
            handleHowToUse={handleHowToUse}
            location={`dashboard`}
            userState={userState}
          />
        </ErrorBoundary>

        <ErrorBoundary
          page={"dashboard"}
          section={"crops-list"}
          userSource={userSource}
        >
          <CropsListContainer
            allMeetingsByCrop={allMeetingsByCrop}
            loading={loadingCropList}
            title={
              messages["dashboard.cropsList.sectionTitle"][userLanguageCode]
            }
            userType={userType}
            farmerCrops={farmerCrops}
            cropList={cropList}
            userState={userState}
            userSource={userSource}
          />
        </ErrorBoundary>

        {/*{userLanguageCode &&*/}
        {/*  userState &&*/}
        {/*  userState.code === "MH" &&*/}
        {/*  Date.now() < 1616596200000 && (*/}
        {/*    <SpecialEvents language={userLanguageCode} />*/}
        {/*  )}*/}

        {/*<JWTTokenContext.Provider value={jwtToken}>*/}
        {/*  {userSource === "WEB" && (*/}
        {/*    <ErrorBoundary*/}
        {/*      page={"dashboard"}*/}
        {/*      section={"upcoming-meetings"}*/}
        {/*      userSource={userSource}*/}
        {/*    >*/}
        {/*      <UpcomingContentContainer*/}
        {/*        allUpcomingMeetings={allUpcomingMeetings}*/}
        {/*        upcomingMeetings={upcomingMeetings}*/}
        {/*        loading={loadingUpcomingMeetings}*/}
        {/*        recordedMeetings={recordedMeetings}*/}
        {/*        liveMeetings={liveMeetings}*/}
        {/*        loadingRecordedMeetings={loadingRecordedMeetings}*/}
        {/*        allMeetingsByCrop={allMeetingsByCrop}*/}
        {/*        crops={props.referenceData.crops}*/}
        {/*        userType={userType}*/}
        {/*        farmerCrops={farmerCrops}*/}
        {/*        userSource={userSource}*/}
        {/*      />*/}
        {/*    </ErrorBoundary>*/}
        {/*  )}*/}
        {/*</JWTTokenContext.Provider>*/}
        {userType !== "free_premium" && userSource === "WEB" && (
          <ErrorBoundary
            page={"dashboard"}
            section={"live-help"}
            userSource={userSource}
          >
            <LiveHelpContainer
              meetings={liveHelpVideos}
              loading={loadingLiveHelpMeetings}
              userState={userState}
              userType={userType}
              farmerCrops={farmerCrops}
              userSource={userSource}
            />
          </ErrorBoundary>
        )}

        {/* {userState &&
          userState.name_en &&
          userState.name_en.toLowerCase() === "maharashtra" && (
            <HowToUseContainer
              userType={props.userType}
              userLanguageCode={userLanguageCode}
              loading={loadingLiveHelpMeetings && loadingUpcomingMeetings}
              mobile={mobile}
              userState={userState}
            />
          )} */}

        {userSource === "WEB" && (
          <ErrorBoundary
            page={"dashboard"}
            section={"testimonials"}
            userSource={userSource}
          >
            <div
              className={
                free ? classes.carousalMarginPaid : classes.carousalMarginPaid
              }
            >
              <CarousalContainer
                videos={successVideos}
                title={
                  messages["dashboard.live.successStoriesTitle"][
                    userLanguageCode
                  ]
                }
                background={"#f1f1f1"}
                userState={userState}
                mobile={mobile}
                userType={userType}
                classes={classes}
                userSource={userSource}
              />
            </div>
          </ErrorBoundary>
        )}

        <ErrorBoundary
          page={"dashboard"}
          section={"referral"}
          userSource={userSource}
        >
          <Refcard
            state={userState ? userState.code : ""}
            mobile={mobile}
            userType={userType}
            userData={userData}
            cardVisibility={userType !== "free_premium" && userSource === "WEB"}
            userSource={userSource}
          />
        </ErrorBoundary>

        <ErrorBoundary
          page={"dashboard"}
          section={"welcome-dialog"}
          userSource={userSource}
        >
          <WelcomeDialog
            handleClose={handleClose}
            open={openWelcome}
            handleWelcome={handleWelcome}
            userSource={userSource}
          />
        </ErrorBoundary>

        <ErrorBoundary
          page={"dashboard"}
          section={"lead-dialog"}
          userSource={userSource}
        >
          <LeadDialog
            handleClose={handleCloseLeadRegistrationSuccess}
            open={openLeadRegistrationSuccess}
            userSource={userSource}
          />
        </ErrorBoundary>

        <ErrorBoundary
          page={"dashboard"}
          section={"howtouse-dialog"}
          userSource={userSource}
        >
          <HowToUseDialog
            handleClose={handleCloseHowToUseVideo}
            open={openHowToUseVideo}
            userSource={userSource}
          />
        </ErrorBoundary>

        {userSource === "WEB" && (
          <ErrorBoundary
            page={"dashboard"}
            section={"footer"}
            userSource={userSource}
          >
            <BottomBar
              languages={props.referenceData.languages}
              location={"dashboard"}
              changeUserLanguage={props.changeUserLanguage}
              userSource={userSource}
            />
          </ErrorBoundary>
        )}
      </LanguageContext.Provider>
    </div>
  );
}

export default Dashboard;
